import LazyLoad from 'vanilla-lazyload';

export class lazyLoad {
    constructor() {
        new LazyLoad({
            
        });
    }
}